import { Button } from '@trm/ui-kit';

import { LFA_COST_DISCLAIMER, useLfaFooterDisclaimer } from './lfaFooterDisclaimer';

const Footer = () => {
  const { show } = useLfaFooterDisclaimer();

  return (
    <div className="mt-auto flex flex-row items-center justify-between px-4 pt-6">
      <div className="flex flex-row items-center gap-x-4">
        <p className="text-secondary">&copy; All rights reserved</p>
        {show ? <p className="text-secondary">{LFA_COST_DISCLAIMER}</p> : null}
      </div>
      <div className="flex flex-row items-center justify-between gap-3">
        <Button href="https://www.topstep.com/about-us/" target="_blank" color="link-color">
          About us
        </Button>
        <Button href="https://www.topstep.com/privacy-policy/" target="_blank" color="link-color">
          Privacy
        </Button>
        <Button href="https://www.topstep.com/terms-of-use/" target="_blank" color="link-color">
          Terms
        </Button>
      </div>
    </div>
  );
};

export default Footer;
